import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export function blockFourColumnTextIconScript() {
  const blocks = document.querySelectorAll('.blockFourColumnTextIcon__list');
  blocks.forEach(block=>{
    new Splide(block, {
        cover: true,
        perPage: 3,
        perMove: 1,
        breakpoints: {
            
            767: {
              perPage: 2,
          
            },
          },
      }).mount();
  })
}